import * as t from "io-ts";

export const ApiId = t.string;
export const ApiResourceId = ApiId;
